import { toast } from "sonner";
import { resolveEntityFile } from "@/react/components/entityViews/files/api/files.api";
import type { SwivuFile } from "@/react/components/entityViews/files/types/swivuFile";
import type { EntityRecord } from "@/types/entity";
import {
  ENTITY_RECORD_FIELD_TO_API,
  type MarketingAssetEntityType,
} from "../api/marketingAssets.query-keys";

/**
 * Resolve a marketing asset's Swivu file for FileDetailModal.
 * Returns null and toasts on failure / missing context.
 *
 * No loading toast — resolve can race with UI (File Detail + Promote open
 * while a delayed "Opening file…" toast is still scheduled), which left the
 * loader stuck on screen.
 */
export async function resolveMarketingAssetFile({
  boardId,
  entityRecord,
  fileId,
}: {
  boardId: number | undefined;
  entityRecord: EntityRecord;
  fileId: number | null | undefined;
}): Promise<SwivuFile | null> {
  if (!fileId || !boardId) {
    toast.error("Unable to open file preview");
    return null;
  }
  const entityType = ENTITY_RECORD_FIELD_TO_API[entityRecord.entityType] as
    | MarketingAssetEntityType
    | undefined;
  if (!entityType) {
    toast.error("Unable to open file preview");
    return null;
  }

  try {
    return await resolveEntityFile({
      boardId,
      entityType,
      entityId: Number(entityRecord.id),
      fileId,
    });
  } catch {
    toast.error("Unable to open file preview");
    return null;
  }
}
